@if (loading) {
    <div class="flex flex-column gap-3">
        <p-skeleton height="4rem"></p-skeleton>
        <p-skeleton height="3rem"></p-skeleton>
        <p-skeleton height="3rem"></p-skeleton>
    </div>
} @else if (!result) {
    <div class="surface-card border-round-lg p-5 flex flex-column align-items-center gap-3 text-center">
        <i class="fa-regular fa-clipboard-check text-4xl text-color-secondary"></i>
        <span class="text-color-secondary">Konfigurationsprüfung wird geladen...</span>
        <p-button
            label="Prüfung starten"
            icon="fa-solid fa-rotate"
            severity="primary"
            (click)="refresh()"
        ></p-button>
    </div>
} @else {

    <!-- Summary Dashboard - Compact Inline -->
<!--    <div class="flex align-items-center gap-4 mb-3 py-3 border-bottom-1 border-200 surface-50 px-3 border-round-sm">-->
<!--        <div class="flex align-items-center gap-2"-->
<!--             [class.text-red-500]="result.totalErrors > 0"-->
<!--             [class.text-color-secondary]="result.totalErrors === 0">-->
<!--            <i class="fa-solid fa-circle-xmark"></i>-->
<!--            <span class="font-bold">{{ result.totalErrors }}</span>-->
<!--            <span class="text-sm">Fehler</span>-->
<!--        </div>-->
<!--        <div class="border-left-1 border-300 h-1rem"></div>-->
<!--        <div class="flex align-items-center gap-2"-->
<!--             [class.text-yellow-600]="result.totalWarnings > 0"-->
<!--             [class.text-color-secondary]="result.totalWarnings === 0">-->
<!--            <i class="fa-solid fa-triangle-exclamation"></i>-->
<!--            <span class="font-bold">{{ result.totalWarnings }}</span>-->
<!--            <span class="text-sm">Warnungen</span>-->
<!--        </div>-->
<!--        <div class="border-left-1 border-300 h-1rem"></div>-->
<!--        <div class="flex align-items-center gap-2">-->
<!--            @if (result.totalErrors === 0 && result.totalWarnings === 0) {-->
<!--                <i class="fa-solid fa-circle-check text-green-500"></i>-->
<!--                <span class="font-bold text-green-500">Bereit</span>-->
<!--            } @else {-->
<!--                <i class="fa-solid fa-clock text-color-secondary"></i>-->
<!--                <span class="text-color-secondary text-sm">Unvollständig</span>-->
<!--            }-->
<!--        </div>-->
<!--    </div>-->

    <!-- Filter Tabs -->
    <div class="flex align-items-center justify-content-between mb-3">
        <div class="flex border-1 border-300 border-round-lg overflow-hidden">
            <div class="px-3 py-2 cursor-pointer text-sm font-medium transition-colors"
                 [ngClass]="activeFilter === 'all' ? 'bg-primary text-white' : 'surface-50 hover:surface-100'"
                 (click)="setFilter('all')">
                Alle
            </div>
            <div class="px-3 py-2 cursor-pointer text-sm font-medium transition-colors border-left-1 border-300"
                 [ngClass]="activeFilter === 'errors' ? 'bg-red-500 text-white' : 'surface-50 hover:surface-100'"
                 (click)="setFilter('errors')">
                Fehler ({{ result.totalErrors }})
            </div>
            <div class="px-3 py-2 cursor-pointer text-sm font-medium transition-colors border-left-1 border-300"
                 [ngClass]="activeFilter === 'warnings' ? 'bg-yellow-500 text-white' : 'surface-50 hover:surface-100'"
                 (click)="setFilter('warnings')">
                Warnungen ({{ result.totalWarnings }})
            </div>
        </div>
        <p-button
            icon="fa-solid fa-rotate"
            severity="secondary"
            [text]="true"
            [rounded]="true"
            size="small"
            pTooltip="Prüfung aktualisieren"
            ariaLabel="Prüfung aktualisieren"
            (click)="refresh()"
        ></p-button>
    </div>

    <!-- Check Entries List -->
    @if (filteredEntries.length === 0) {
        <div class="surface-card border-round-lg p-4 flex flex-column align-items-center gap-2 text-center">
            @if (activeFilter === 'all') {
                <i class="fa-solid fa-circle-check text-3xl text-green-500"></i>
                <span class="text-lg font-semibold text-green-600">Alle Prüfungen bestanden</span>
                <span class="text-color-secondary text-sm">Die Konfiguration ist vollständig und bereit zum Einsatz.</span>
            } @else {
                <i class="fa-regular fa-filter text-3xl text-color-secondary"></i>
                <span class="text-color-secondary">Keine {{ activeFilter === 'errors' ? 'Fehler' : 'Warnungen' }} gefunden.</span>
            }
        </div>
    } @else {
        <div class="flex flex-column gap-2">
            @for (entry of filteredEntries; track (entry.checkCode || '') + (entry.severity || '') + (entry.message || '')) {
                <div class="surface-card border-round-lg p-3 border-left-3"
                     [class.border-red-500]="entry.severity === 2"
                     [class.border-yellow-500]="entry.severity === 1"
                     [class.border-green-500]="entry.severity === 0"
                >
                    <div class="flex align-items-start gap-3">
                        <i [class]="getSeverityIcon(entry.severity)" class="text-lg mt-1"></i>
                        <div class="flex flex-column gap-1 flex-1">
                            <div class="flex align-items-center gap-2">
                                <span class="font-medium">{{ entry.message }}</span>
                                @if (entry.checkCode) {
                                    <p-tag [value]="entry.checkCode" severity="secondary" styleClass="text-xs"></p-tag>
                                }
                                @if (entry.checkGroup) {
                                    <p-tag [value]="getGroupLabel(entry.checkGroup)" [severity]="getSeverityTagSeverity(entry.severity)" styleClass="text-xs"></p-tag>
                                }
                            </div>
                            @if (entry.solution) {
                                <div class="flex align-items-center gap-1 text-sm">
                                    <i class="fa-regular fa-lightbulb text-color-secondary"></i>
                                    <span class="text-color-secondary">{{ entry.solution }}</span>
                                </div>
                            }
                            @if (entry.referenceEntityName) {
                                <div class="text-xs text-color-secondary mt-1">
                                    <i class="fa-regular fa-link mr-1"></i>
                                    {{ entry.referenceEntityType }}: {{ entry.referenceEntityName }}
                                </div>
                            }
                        </div>
                        @if (!isCopyMode && getStepForGroup(entry.checkGroup) !== null) {
                            <button pButton
                                    icon="fa-regular fa-pen-to-square"
                                    label="Beheben"
                                    class="p-button-text p-button-sm flex-shrink-0"
                                    (click)="navigateToStep(entry.checkGroup)">
                            </button>
                        }
                    </div>
                </div>
            }
        </div>
    }

}
